import { Card as MuiCard, withStyles } from '@material-ui/core';

export const Card = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    display: 'flex',
    boxShadow: 'initial',
    borderRadius: 0,
    padding: theme.spacing(2, 4),
    flexDirection: 'column',
    justifyContent: 'space-between',
    '& > *': { padding: 0 },
  },
}))(MuiCard);
